export const metadataUrl = '/metadata/describeMetadata';
export const typeParameter = 'typeNames';
export const flagParameter = 'flags';
export interface Config {
  serverUrl: string;
  webUrl: string;
  buildNo: string;
}
export const getMetadataUrl = async () => {
  const response = await window.fetch('./config/config.json');
  const config = await response.json() as Config;
  return config.webUrl;
};

export const getConfig = async () => {
  return await (await window.fetch('./config/config.json')).json() as Config
}
